import { useCookieConsent } from '@/contexts/CookieConsentContext';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Cookie, Settings } from 'lucide-react';

export function CookieConsentBanner() {
  const { showBanner, acceptAll, rejectAll, openSettings } = useCookieConsent();

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-background/95 backdrop-blur-sm border-t">
      <Card className="mx-auto max-w-4xl">
        <CardContent className="p-4">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <div className="flex items-center gap-3 flex-1">
              <Cookie className="h-6 w-6 text-primary shrink-0" />
              <div className="text-sm">
                <p className="font-medium mb-1">This website uses cookies</p>
                <p className="text-muted-foreground">
                  We use cookies to make this site better every day. Click accept to help us get better.
                </p>
              </div>
            </div>
            
            <div className="flex flex-wrap gap-2 shrink-0">
              <Button
                variant="outline"
                size="sm"
                onClick={rejectAll}
                className="text-xs"
              >
                Reject All
              </Button>
              <Button
                variant="outline"
                size="sm"
                onClick={openSettings}
                className="text-xs"
              >
                <Settings className="h-3 w-3 mr-1" />
                Customize
              </Button>
              <Button
                size="sm"
                onClick={acceptAll}
                className="text-xs"
              >
                Accept All
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}